import React from 'react'
import * as GestureHandler from 'react-native-gesture-handler'
import { TouchableOpacity } from 'react-native'
import { Icon } from 'react-native-elements'
import { useTranslation } from 'react-i18next'
import { DeviceInfo } from 'react-native-web'
import NavigationTitle from './NavigationTitle'
import { colors } from '../styles'
import { trackEventAndNavigate, trackEventAndPop, trackEventAndPopCount } from '../actions/helpers'

const defaultOptions = (titleStyle) => ({
  headerStyle: {
    backgroundColor: colors.bscBlue,
    elevation: 0,
    shadowOpacity: 0,
    borderBottomWidth: 0,
    height: titleStyle === 'large' ? 75 : 56,
  },
  headerTintColor: colors.white,
  gesturesEnabled: false,
  headerTitleAlign: 'center',
  headerBackTitleVisible: false,
  swipeEnabled: false,
  cardStyle: { flex: 1 },
})

export const hiddenItem = (hideHeader) => ({
  headerShown: !hideHeader,
  headerTitle: null,
  unmountOnBlur: true,
})

export const noNav = (titleKey, titleStyle) => ({
  ...defaultOptions(),
  headerTitle: () => <NavigationTitle path={titleKey} titleStyle={titleStyle} widthStyle="large" />,
  unmountOnBlur: true,
  headerLeft: null,
  headerRight: null,
  swipeEnabled: false,
})

export const backWithFunctionSubCall = (TouchableObj, screenId, titleKey, titleStyle, onPress) => ({
        ...defaultOptions(titleStyle),
        headerLeft: () => (
          <TouchableObj
            testID={`back-btn-${screenId}`}
            accessibilityLabel={useTranslation(['access']).t('backButton')}
            onPress={onPress}
            style={{
                    flex: 1,
                    justifyContent: 'center',
                    marginHorizontal: 16,
                    alignItems: 'center',
                    marginBottom: 5,
                }}
          >
            <Icon testID={`back-btn-icon-${screenId}`} accessibilityLabel="back arrow icon" name="arrow-left" type="material-community" size={24} color={colors.white} />
          </TouchableObj>
        ),
        headerTitle: () => (titleKey ? <NavigationTitle path={titleKey} titleStyle={titleStyle} /> : null),
    }
)

export const backWithFunction = (screenId, titleKey, titleStyle, onPress) => {
    const agentUpper = DeviceInfo.userAgent.toUpperCase()
    // this touchable is for testing... XCUITest need the specific version of TouchableOpacity but Espresso needs regular one.
    const touchable = agentUpper.includes('IPHONE') ? GestureHandler.TouchableOpacity : TouchableOpacity
    return backWithFunctionSubCall(touchable, screenId, titleKey, titleStyle, onPress)
}

export const backToPage = (numberOfScreens, screenId, titleKey, titleStyle) => {
  const onPress = () => { trackEventAndPopCount(numberOfScreens, 'exit') }
  return backWithFunction(screenId, titleKey, titleStyle, onPress)
}

export const backOption = (screenId, titleKey, titleStyle) => {
  const onPress = () => {
    trackEventAndPop('back')()
  }
  return backWithFunction(screenId, titleKey, titleStyle, onPress)
}

export const backWebOption = (screenId, sameWebView, postMessage, titleKey, titleStyle) => {
  if (!sameWebView && window.ReactNativeWebView) {
    const goBackToReactNative = () => {
      window.ReactNativeWebView.postMessage(postMessage || 'pop') // 'backToTabbedWebView')
    }
    return backWithFunction(screenId, titleKey, titleStyle, goBackToReactNative)
  }
  return backOption(screenId, titleKey, titleStyle)
}

export const backToGlobalOption = (screenId, sameWebView, titleKey, titleStyle) => {
  if (!sameWebView && window.ReactNativeWebView) {
    const goBackToReactNative = () => {
      window.ReactNativeWebView.postMessage('backToGlobal')
    }
    return backWithFunction(screenId, titleKey, titleStyle, goBackToReactNative)
  }
  return backOption(screenId, titleKey, titleStyle)
}

export const closeWithFunction = (componentName, titleKey, onPress) => ({
  ...defaultOptions(),
  headerLeft: () => (
    <TouchableOpacity
      accessibilityLabel={useTranslation(['access']).t('closeButton')}
      testID={componentName ? `close-btn-${componentName}` : 'close-btn'}
      onPress={onPress}
      style={{
        flex: 1,
        justifyContent: 'center',
        marginHorizontal: 16,
        alignItems: 'center',
        marginBottom: 5,
      }}
    >
      <Icon name="close" type="material-community" size={24} color={colors.white} />
    </TouchableOpacity>
  ),
  headerShown: true,
  title: (titleKey ? <NavigationTitle path={titleKey} /> : null),
})

export const closeByPageNum = (screenId, options) => {
  const { numberOfScreens, titleKey } = options
  const onPress = () => {
    trackEventAndPopCount(numberOfScreens, 'close')
  }
  return closeWithFunction(screenId, titleKey, onPress)
}

export const closeOption = (screenId, titleKey, previousPage) => {
  const onPress = () => {
    if (previousPage) {
      trackEventAndNavigate(previousPage, 'close')
    } else {
      trackEventAndPop('close')()
    }
  }
  return closeWithFunction(screenId, titleKey, onPress)
}

export const closeWebView = (screenId, options) => {
  const { titleKey, titleStyle } = options
  if (window.ReactNativeWebView) {
    const goBackToReactNative = () => {
      window.ReactNativeWebView.postMessage('pop')
    }
    return closeWithFunction(screenId, titleKey, goBackToReactNative)
  }
  return closeOption(screenId, titleKey, titleStyle)
}
